import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=29215d45&scoped=true&"
import script from "./menu-item.vue?vue&type=script&lang=js&"
export * from "./menu-item.vue?vue&type=script&lang=js&"
import style0 from "./menu-item.vue?vue&type=style&index=0&id=29215d45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29215d45",
  null
  
)

export default component.exports